import React from 'react';
import styled from 'styled-components';
import Icon from '../../Icon';

const LegendContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-top: 20px;

  .itemContainer {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    :not(:last-child) {
      margin-right: 3%;
    }
    p {
      font-family: ${(props) => props.theme.fonts.sfcompact_text};
      font-size: 12px;
    }
    font-size: 12px;
    text-transform: capitalize;
  }

  @media (max-width: ${(props) =>
      props.theme.devices.isTablet ? '0px' : '845px'}) {
    flex-direction: column;
    align-items: flex-start;
    margin-left: 40%;

    .itemContainer {
      margin-right: 0px;
    }
  }

  ${(props) =>
    props.nbItems &&
    props.nbItems > 2 &&
    `@media (max-width: 1700px) and (min-width: 845px) {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    margin-left: 15%;
    grid-gap: 10px;

    .itemContainer {
      margin-right: 0px;
      justify-content: flex-start;
    }
  }}`}

  ${(props) => props.styles}
`;
const LegendItem = styled.div`
  width: 40px;
  height: 20px;
  background-color: ${(props) => props.color};
  margin-right: 20px;
`;

const LineIcon = styled.div`
  color: ${(props) => props.color};
  font-size: 12px;
  margin-right: 10px;
`;

const Legend = ({ labels, type, colors }) => (
  <LegendContainer nbItems={(labels && labels.length) || 0}>
    {labels.map((entry, index) => (
      <div className="itemContainer" key={`legend-${index}`}>
        {type === 'line' ? (
          <LineIcon color={colors[index]}>
            <Icon icon="legendLineIcon" />
          </LineIcon>
        ) : (
          <LegendItem color={colors[index]} />
        )}
        <p key={`item-${index}`}>{labels[index]}</p>
      </div>
    ))}
  </LegendContainer>
);

export default Legend;
